module.exports = __webpack_public_path__ + "static/media/slider_active_boostabostad.530fd672.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_active_boostabostad.svg
// module id = 56
// module chunks = 0